// Module
var code = `<div class="page-content w-full">
<!--
  <div class="flex w-full items-center justify-between">
    <h1 class="font-lusitana text-2xl">{{pageHeading}}</h1>
  </div>
-->

  <!-- Search + Create Invoice sit on one row -->
  <div
    data-region="toolbar"
    class="mt-4 flex items-center justify-between gap-2 md:mt-8"
  ></div>

  <!-- InvoicesTableView -->
  <div data-region="main"></div>

  <!-- InvoicesSaveBarView — the unsaved-edits / bulk-actions bar -->
  <div data-region="savebar"></div>

  <!-- Pagination is centered on its own row -->
  <div data-region="pagination" class="mt-5 flex w-full justify-center"></div>
</div>
`;
// Exports
module.exports = code;